import(/* webpackMode: "eager" */ "/home/runner/work/mono/mono/moxie_suite_ui/app/template.tsx");
